<template>
  <HomeLayout>
    <b-row class="column-border-container">
      <b-col class="column-border card-col col-12" :class="setColumns">
        <div @click="openSeatingMessagesModal" class="vtd-card vtd-animate-shake">
          <div class="navigation-block">
            <h4 class="nav-title-center">SEATING</h4>
            <div class="nav-text-center">
              <i class="icon-seating vtd-icon-7" />
            </div>
          </div>

          <SeatingMessagesModal 
            ref="SeatingMessagesModalRef" 
            @openDetailedFlightsInfo="openDetailedFlightsInfo" 
            @issue-flights-response="handleIssueFlightsResponse" 
          />
          <MakeAPayment ref="MakeAPayment" />

          <div class="vtd-card-footer nav-text-center d-none d-lg-block">
            <p class="vtd-home-btn text-center">View Now</p>
          </div>
        </div>
      </b-col>

      <b-col class="column-border card-col col-12" :class="setColumns">
        <router-link :to="{
          name: 'baggage-landing',
          params: {
            tripHub: 'Trip Hub',
          },
        }" class="vtd-card vtd-animate-shake">
          <div class="navigation-block">
            <h4 class="nav-title-center">BAGGAGE</h4>
            <div class="nav-text-center">
              <i class="icon-checked_baggage vtd-icon-7" />
            </div>
          </div>
          <div class="vtd-card-footer nav-text-center d-none d-lg-block">
            <p class="vtd-home-btn text-center">View Now</p>
          </div>
        </router-link>
      </b-col>

      <b-col v-if="flightsdata === 'true'" class="column-border card-col col-12" :class="setColumns">
        <div @click="openDetailedFlightsInfo" class="vtd-card vtd-animate-shake">
          <div class="navigation-block">
            <h4 class="nav-title-center">DETAILED FLIGHT INFORMATION</h4>
            <div class="nav-text-center">
              <i class="icon-flight_info vtd-icon-7" />
            </div>
          </div>
          <DetailedFlights ref="DetailedFlightsRef" />
          <div class="vtd-card-footer nav-text-center d-none d-lg-block">
            <p class="vtd-home-btn text-center">View Now</p>
          </div>
        </div>
      </b-col>

      <b-col v-if="FIL === 'M'" class="column-border card-col col-12" :class="setColumns">
        <div @click="openCheckinModal" class="vtd-card vtd-animate-shake">
          <div class="navigation-block">
            <h4 class="nav-title-center">MANAGE &amp; CHECK-IN</h4>
            <div class="nav-text-center">
              <i class="icon-manage_and_check_in vtd-icon-7" />
            </div>
          </div>
          <Checkin ref="CheckinInfoRef" />
          <div class="vtd-card-footer nav-text-center d-none d-lg-block">
            <p class="vtd-home-btn text-center">View Now</p>
          </div>
        </div>
      </b-col>

      <b-col class="column-border card-col col-12" :class="setColumns">
        <div @click="openETicketsModal" class="vtd-card vtd-animate-shake">
          <div class="navigation-block">
            <h4 class="nav-title-center">E-TICKETS</h4>
            <div class="nav-text-center">
              <i class="icon-e_ticket vtd-icon-7" />
            </div>
          </div>
          <AirlineTicket ref="AirlineTicketRef" />
          <div class="vtd-card-footer nav-text-center d-none d-lg-block">
            <p class="vtd-home-btn text-center">View Now</p>
          </div>
        </div>
      </b-col>

      <b-col v-if="hasAirlineInfo" class="column-border card-col col-12"
        :class="setColumns">
        <div @click="openAirlineInfoModal" class="vtd-card vtd-animate-shake">
          <div class="navigation-block">
            <h4 class="nav-title-center">AIRLINE INFORMATION</h4>
            <div class="nav-text-center">
              <i class="icon-flight vtd-icon-7" />
            </div>
          </div>
          <SQLMessage ref="SQLMessageRef" />
          <div class="vtd-card-footer nav-text-center d-none d-lg-block">
            <p class="vtd-home-btn text-center">View Now</p>
          </div>
        </div>
      </b-col>
    </b-row>
    <HomeBackBtns />
  </HomeLayout>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import HomeLayout from "@/partials/home-layout";
import SQLMessage from "@/modules/menu-bar/essential-info/sql-message";
import AirlineTicket from "@/modules/menu-bar/essential-info/airline-etickets";
import Checkin from "@/modules/menu-bar/essential-info/checkin";
import DetailedFlights from "@/modules/navigation/modals/detailed-flights";
import SeatingMessagesModal from "@/modules/navigation/modals/seating-messages"
import MakeAPayment from "@/modules/navigation/modals/payment-hub/make-payment";

export default {
  components: {
    HomeLayout,
    SQLMessage,
    AirlineTicket,
    Checkin,
    DetailedFlights,
    SeatingMessagesModal,
    MakeAPayment,
  },
  data() {
    return {
      sqlSeating: {},
      sqlAirlineInfo: {},
      FIL: null,
      loginRes: {},
    };
  },
  async created() {
    if (this.essentialInfoMenu) {
      this.setSeating();
      this.setAirlineInfo();
    }
    if (this.booking && this.booking.booking_information) {
      this.FIL = this.booking.booking_information.fil;
    }
    if (this.$route.name === "flightsAuth") {
      this.loginRes = await this.loginOnStart({
        username: this.$route.params.surname,
        bookingNumber: this.$route.params.bookingNumber,
        source: this.$route.params.source,
      });
    }
    if (!this.loginRes) {
      this.$router.push("/login");
    }
  },
  updated() {
    if (this.booking && this.booking.booking_information) {
      this.FIL = this.booking.booking_information.fil;
    }
    if (this.flightsdata && this.$route.query.pop === "dfi") {
      this.openDetailedFlightsInfo();
    }
    this.stopLoading();
  },
  computed: {
    ...mapGetters({
      booking: "booking/getBooking",
      essentialInfoMenu: "essentialInfoMenu/getMenu",
      flightsdata: "booking/getLiveFlights",
    }),
    // Airline Information arrives either as an Airline Information submenu item
    // carrying sqlCodes, or as free text notes on the Air Travel item
    hasAirlineInfo() {
      return (
        Object.keys(this.sqlAirlineInfo).includes("sqlCodes") ||
        Array.isArray(this.sqlAirlineInfo.message)
      );
    },
    setColumns() {
      let columns = "col-lg";
      if (this.flightsdata === "true" && this.hasAirlineInfo && this.FIL !== "P") {
        columns = "col-lg-4";
      }
      return columns;
    },
  },
  methods: {
    ...mapActions({
      loginOnStart: "auth/loginBookingNumberOnStartAction",
    }),
    setSeating() {
      this.essentialInfoMenu.forEach((info) => {
        if (Array.isArray(info.submenu)) {
          info.submenu.forEach((item) => {
            if (item.partial === "SQLMessageRef" && item.title === "Seating") {
              this.sqlSeating = item;
            }
          });
        }
      });
    },
    setAirlineInfo() {
      this.essentialInfoMenu.forEach((info) => {
        if (Array.isArray(info.submenu)) {
          info.submenu.forEach((item) => {
            if (
              item.partial === "SQLMessageRef" &&
              item.title === "Airline Information"
            ) {
              this.sqlAirlineInfo = item;
            }
          });
        }
        // vt-api hangs free text notes (currently Ryanair) off the Air Travel
        // item itself rather than a submenu entry, so merge those in too
        if (info.title === "Air Travel" && Array.isArray(info.message)) {
          this.sqlAirlineInfo = {
            ...this.sqlAirlineInfo,
            title: "Airline Information",
            message: info.message,
          };
        }
      });
    },
    openSeatingModal() {
      this.$refs.SQLMessageRef.showModal(this.sqlSeating);
    },
    openSeatingMessagesModal() {
      this.$refs.SeatingMessagesModalRef.showModal({ from: 'tripHub' })
    },
    openAirlineInfoModal() {
      this.$refs.SQLMessageRef.showModal(this.sqlAirlineInfo);
    },
    openDetailedFlightsInfo() {
      this.$refs.DetailedFlightsRef.showModal();
    },
    openCheckinModal() {
      this.$refs.CheckinInfoRef.showModal();
    },
    openETicketsModal() {
      this.$refs["AirlineTicketRef"].showModal({
        partial: "AirlineTicketRef",
        title: "Airline E-Ticket Numbers",
      });
    },
    stopLoading() {
      this.$emit("loading-bar", false);
    },
    handleIssueFlightsResponse(agreed) {
      if (agreed) {
        this.$refs.MakeAPayment.showModal({ issueFlights: true });
        // show payment modal with checkbox pre-ticked
      }
    },
  },
};
</script>
